import { Card, CardContent, CardHeader, Skeleton } from '@mui/material'
import { FC } from 'react'
import { SkeletonText } from 'utoniq-ui'

export type PostBoxSkeletonProps = {
  fullWidth?: boolean
}

export const PostBoxSkeleton: FC<PostBoxSkeletonProps> = ({ fullWidth }) => {
  return (
    <Card sx={{ width: fullWidth ? '100%' : 315, minHeight: 196 }}>
      <CardHeader
        sx={{ pb: 0 }}
        avatar={<Skeleton variant="circular" width={36} height={36} />}
        title={<SkeletonText variant="medium" width="75%" />}
      />
      <CardContent sx={{ pt: 3 }}>
        <SkeletonText variant="medium" numberOfLine={3} lastWidth="75%" />
      </CardContent>
    </Card>
  )
}
